var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXiaomi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 52.917 52.917",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath831"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.28 H 841.89 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.6659 -106.33)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 -186.45 261.78)",
    clipPath: "url(#clipPath831)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4354 0 0 1.4355 -242.08 -126.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m656.46 290.64h-96.563c-2.191 0-3.967 1.776-3.967 3.967v96.563c0 2.191 1.776 3.966 3.967 3.966h96.563c2.191 0 3.967-1.775 3.967-3.966v-96.563c0-2.191-1.776-3.967-3.967-3.967",
    fill: "#ff6700",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m637.87 362.27h-8.221c-0.352 0-0.637-0.28-0.637-0.625v-37.509c0-0.342 0.285-0.622 0.637-0.622h8.221c0.349 0 0.638 0.28 0.638 0.622v37.509c0 0.345-0.289 0.625-0.638 0.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609.8 362.27h-31.315c-0.352 0-0.635-0.28-0.635-0.625v-37.509c0-0.342 0.283-0.622 0.635-0.622h8.223c0.35 0 0.64 0.28 0.64 0.622v29.439c0 0.34 0.283 0.622 0.635 0.622h17.713c4.981 0 6.395-3.815 6.395-6.276v-23.785c0-0.342 0.286-0.622 0.638-0.622h8.218c0.35 0 0.637 0.28 0.637 0.622v26.609c0 2.195-0.264 5.351-3.096 8.129-2.963 2.9-5.666 3.396-8.688 3.396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604.04 347.33h-8.633c-0.352 0-0.641-0.28-0.641-0.623v-22.574c0-0.341 0.289-0.621 0.641-0.621h8.633c0.349 0 0.635 0.28 0.635 0.621v22.574c0 0.343-0.286 0.623-0.635 0.623"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXiaomi);
export default __webpack_public_path__ + "static/media/xiaomi.e02edaa045834fea7707c7a9d4f039b8.svg";
export { ForwardRef as ReactComponent };